import { Response } from 'external/rocket-chat/api/api_pb';

import { getStickerQuery, getBizAccountQuery } from 'utils/protobuf/query';

import { ROCKET_CHAT_URL, IS_SERVER } from 'constants/config';
import { SOCKET_RETRY_DEFAULT_TIME, SOCKET_RETRY_MAX_TIME } from 'constants/resource';
import { chatResParser } from './socketDataParser';
import { openLoader } from 'utils/localDispatcher';
import { store } from 'store';
import { socketStore } from 'utils/socket/socketStore';
import { logLevel } from 'utils/consoleLevel';
import { deleteToken } from 'utils/auth/tokenUtils';
import { encodeAuthentication, isBizAccessToken, isOIDCAccessToken, isQRAccessToken, type Authentication } from './authentication';

let backOffRetryTime = SOCKET_RETRY_DEFAULT_TIME;
interface socketGeneratorArgs {
  region: string
  authentication: Authentication
}

function chatSocketInit({ region, authentication }: socketGeneratorArgs) {
  if (!IS_SERVER) {
    logLevel.log('socket generate');
    openLoader();

    const queryParams = encodeAuthentication(authentication);
    const url = `${ROCKET_CHAT_URL.replace(':region', region)}?${queryParams}`;
    const socket: WebSocket = new WebSocket(url);
    socket.binaryType = 'arraybuffer';

    socket.onmessage = (event) => {
      const unit8 = new Uint8Array(event.data);
      const res = Response.toObject(false, Response.deserializeBinary(unit8));
      chatResParser(res, socket);
      logLevel.log(res);
    };

    socket.onopen = () => {
      store.dispatch({ type: 'chat/setBizRequestPending', payload: true });
      socket.send(getStickerQuery().serializeBinary());
      socket.send(getBizAccountQuery().serializeBinary());
      store.dispatch({ type: 'socket/socketReadyState', payload: socket.readyState });
    };
    socket.onclose = (e) => {
      logLevel.log('socket is closed!');
      logLevel.log(e);
      logLevel.log({ socket, socketStore });
      store.dispatch({ type: 'socket/socketReadyState', payload: socket.readyState });
     if (e.code === 1002) {
        if (e.reason === "unauthorized") {
          console.log('socket unauthorized.');
          deleteToken();
          alert("로그아웃 되었어요.");
        }
        window.location.href = '/login';
      } else {
        setTimeout(() => {
          let retryAuthentication: Authentication;
          if (isOIDCAccessToken(authentication)) {
            retryAuthentication = { accessToken: store.getState().authStore.oidcAccessToken };
          } else if (isBizAccessToken(authentication)) {
            retryAuthentication = { bizToken: store.getState().authStore.bizToken };
          } else if (isQRAccessToken(authentication)) {
            retryAuthentication = { qrToken: store.getState().authStore.storeAccessToken };
          } else {
            return;
          }

          socketStore.chatSocket = chatSocketInit({ region, authentication: retryAuthentication });
          backOffRetryTime = Math.min(backOffRetryTime * 2, SOCKET_RETRY_MAX_TIME);
        }, backOffRetryTime);
      }
    };
    return socket;
  }

  return null;
}

export { chatSocketInit };
